import { ReportViewerFacade } from '@mode/report-viewer/domain';
import * as angular from 'angular';

import { MixableBaseController } from '~/common/component';

class ReportDetailsNotebookController extends MixableBaseController {
  static $inject = ['ReportViewerFacade'];

  constructor(private reportViewerFacade: ReportViewerFacade) {
    super();
  }
}

export const ID = 'reportDetailsNotebook';

export const reportDetailsNotebook: angular.IComponentOptions = {
  template: `
    <div class="report-details">
      <div class="report-details-tab">
        <notebook-view ng-if="ctrl.reportViewerFacade.hasRun$ | async:this"></notebook-view>
      </div>
    </div>
  `,
  controller: ReportDetailsNotebookController,
  controllerAs: 'ctrl',
};
